export const getQueryParam = (key: string, type?: 'STRING' | 'ARRAY') => {
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);

    switch (type) {
      case 'ARRAY':
        return searchParams.getAll(key);
      default:
        return searchParams.get(key);
    }
  }

  return null;
};
